module.exports = __webpack_public_path__ + "img/kao.e1c8f9d7.jpg";